module.exports = __webpack_public_path__ + "media/auth-right-video.d2065e2e.webm";